<div class="row top10">
  <div class="col-xs-12">
    <div class="row no-gutters seven-cols">
      <div class="col-xs-1 dayOfWeek">
        Sunday
      </div>
      <div class="col-xs-1 dayOfWeek">
        Monday
      </div>
      <div class="col-xs-1 dayOfWeek">
        Tuesday
      </div>
      <div class="col-xs-1 dayOfWeek">
        Wednesday
      </div>
      <div class="col-xs-1 dayOfWeek">
        Thursday
      </div>
      <div class="col-xs-1 dayOfWeek">
        Friday
      </div>
      <div class="col-xs-1 dayOfWeek">
        Saturday
      </div>
    </div>

    <div *ngFor="let day of data; let i = index">
      <div class="row no-gutters seven-cols" *ngIf="returnDayNum(day) == 0">
        <div *ngFor="let weekDay of data.slice(i,i+7)" [ngClass]="{'col-xs-1':true, 'selectedDay':isSelected(weekDay.day), 'monthDay':!isSelected(weekDay.day) }" (click)="clickDay(weekDay)">
          <div class="row no-gutters">
            <div class="col-xs-12 dayTop">
              <span class="dayTopSpan">{{ weekDay.day.format('MMM D') }}</span>
            </div>
          </div>
          <div [ngClass]="{'row':true, 'no-gutters':true, 'dayBottom':true, 'notInMonth':!weekDay.isInSelectedMonth}">
            <div class="col-xs-12">
              <span class="dayBottomSpan">
                <span *ngFor="let schedule of flightsScheduled(weekDay)" >
                  <i class="fas fa-plane monthViewIcon + ' '" [title]="(schedule.name + ' - ' + schedule.siteCode)"></i>
                </span>
                <br />
                <ng-container *ngIf="weekDay.iconCount.maleBeds > 0">
                  <i class="fas fa-mars monthViewIcon" title="Male beds used"></i>
                  <span [innerText]="weekDay.iconCount.maleBeds"></span>
                </ng-container>
                <ng-container *ngIf="weekDay.iconCount.femaleBeds > 0">
                  <i class="fas fa-venus monthViewIcon" title="Female beds used"></i>
                  <span [innerText]="weekDay.iconCount.femaleBeds"></span>
                </ng-container>
                <ng-container *ngIf="weekDay.iconCount.otherBeds > 0" >
                  <i class="fas fa-genderless monthViewIcon" title="Chooses Not to Identify beds used"></i>
                  <span [innerText]="weekDay.iconCount.otherBeds"></span>
                </ng-container>
                <ng-container *ngIf="weekDay.iconCount.military > 0" >
                  <i class="far fa-clipboard monthViewIcon" title="Military"> </i>
                  <span [innerText]="weekDay.iconCount.military"></span>
                </ng-container>
                <ng-container *ngIf="weekDay.iconCount.vip > 0" >
                  <i class="far fa-handshake monthViewIcon" title="VIP"> </i>
                  <span [innerText]="weekDay.iconCount.vip"></span>
                </ng-container>
                <ng-container *ngIf="weekDay.iconCount.san > 0" >
                  <i class="fas fa-flag-checkered monthViewIcon" title="SAN"> </i>
                  <span [innerText]="weekDay.iconCount.san"></span>
                </ng-container>
                <ng-container *ngIf="weekDay.iconCount.sdn > 0" >
                  <i class="fas fa-flag monthViewIcon" title="SDN"> </i>
                  <span [innerText]="weekDay.iconCount.sdn"></span>
                </ng-container>
                <br />
              </span>
              <button *ngIf="weekDay.iconCount.san > 0 || weekDay.iconCount.sdn > 0" class="btn btn-default btn-sm" (click)="displaySAN_SDN(weekDay)">SAN/SDN</button>&nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
